module.exports = __webpack_public_path__ + "static/media/MOLDURA_PES_ISTAMBUL_2023_04-CIRAGAN_PALACE.9eb1f926.png";